<template>
  <router-link :to="{ name: 'Branch', params: { name: string_to_slug(city.name), id:city.id, title:city.name }}" class="city-card" @click.native="onSelect()">
    <img :src="'http://image.tmdb.org/t/p/w185/' + city.poster_path" alt="" class="city-card__cover">
    <div class="city-card__overlay">
      <div class="city-card__title">{{ city.name }}</div>
      <div class="city-card__subtitle">See full serie</div>
      <div class="city-card__number">{{ city.dorms_count }}</div>
    </div>
    <div class="city-card__cnt">
      <v-link
        class="city-card__button"
        :to="{ name: 'City', params: { city: city.slug }}"
        title="Inspect Serie"
      />
    </div>
  </router-link>
</template>

<script>
import Utiliy from '../common'
export default {
  name: 'SerieCard',
  props: {
    city: Object
  },
  methods: {
        string_to_slug (str) {
          return Utiliy.string_to_slug (str)
    },    
    onSelect() {
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('description', this.city.overview)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/city-card";
</style>
